module.exports = __webpack_public_path__ + "img/Tyson_T.8e71cf47.png";